import React from 'react';
import Header from '../component/Header'
import SubBanner from '../component/SubBanner'
import Footer from '../component/Footer';
import CareerContent from '../component/CareerContent';
import { Helmet } from "react-helmet-async";
import '../scss/career.scss' 

function Career() {

  return (
    <> 
      <Helmet>
        <title>Careers | Helpotani</title>
        <meta name="description" content="Join our team at Helpotani. Explore exciting career opportunities and be part of our mission to provide top-quality services." />
        <meta name="keywords" content="Careers, Jobs, Employment, Healthcare, Helpotani, Work with us" />
      </Helmet>

      <main className='career-page'>
        <Header />   
        <SubBanner HeaderTitle="Career" />    
        <div className='career-box'>
          <CareerContent />        
        </div>
      </main>
      <Footer />
    </>
  )
}
export default Career 


